import AlertComponent from '@BUP/components/Generics/Alert'

const AlertInfoNotification = () => {
  return (
    <AlertComponent type='info' message='Recuerda ir registrando toda la información que pueda aportar en el progreso de la investigación y de la denuncia en general. En BRAVE UP! queremos apoyarte en este proceso y para ello cada cierto tiempo te enviaremos correos para recordarte la etapa en la que te encuentras y la información que debes adjuntar.' />
  )
}

export default AlertInfoNotification
